export default function fixedHeader() {

    const header = $('header');

    $(window).on('scroll', function(event) {
        if($(this).scrollTop() > 0 && !header.hasClass('collapsed')) {
            header.addClass('collapsed');
        } else if($(this).scrollTop() === 0  && header.hasClass('collapsed')) {
            header.removeClass('collapsed');
        }

        if($(this).scrollTop() > 70 && !header.hasClass('fully-collapsed')) {
            header.addClass('fully-collapsed');
        } else if($(this).scrollTop() <= 70  && header.hasClass('fully-collapsed')) {
            header.removeClass('fully-collapsed');
        }
    });
}
